import React, { FC, useEffect } from "react";
import { Button, Tooltip } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { PdfReport } from "../../Reports/ExecuteReport/ui/PdfReport";

interface PdfReportModalProps {
  visible: boolean;
  pdfUrl: string | null;
  onClose: () => void;
}

export const PdfReportModal: FC<PdfReportModalProps> = ({
  visible,
  pdfUrl,
  onClose,
}) => {
  const handleEscape = (e: KeyboardEvent) => {
    if (e.key === "Escape" && visible) {
      onClose();
    }
  };

  useEffect(() => {
    if (visible) {
      document.addEventListener("keydown", handleEscape);
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [visible, onClose]);

  if (!visible || !pdfUrl) return null;

  return (
    <>
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-[1000]"
        onClick={onClose}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            onClose();
          }
        }}
        role="button"
        tabIndex={0}
        aria-label="Close modal"
      />
      <div className="fixed inset-0 z-[1001] flex items-center justify-center">
        <div className="bg-white w-full h-full flex flex-col">
          <div className="flex justify-between items-center py-2 px-4 border-b bg-gray-50">
            <h3 className="text-lg font-semibold">Report Preview</h3>
            <Tooltip title="Close (Esc)">
              <Button
                type="primary"
                className="btn-primary--dark text-white !mb-0"
                icon={<CloseOutlined />}
                onClick={onClose}
              >
                Close
              </Button>
            </Tooltip>
          </div>
          <div className="flex-1 overflow-hidden relative">
            <PdfReport key={pdfUrl} pdfUrl={pdfUrl} />
          </div>
        </div>
      </div>
    </>
  );
};
